import { Box } from '@mui/material';
import { DocumentHeaders } from '../../../utils/headers';
import { useCallback } from 'react';
import CustomPagination from '../../../components/Table/CustomPagination';
import DataTable from '../../../components/Table/DataTable';

const DataTableContainer = (props: any) => {
    const {
        handleOpenDrawer,
        documents,
        rowsPerPage,
        loading,
        handleDownloadDocument,
        savingDownload,
        filters,
        setFilters,
        handleDeleteDocument
    } = props;

    const RenderTable = useCallback(() => {
        return (
            <>
                <DataTable
                    handleHistoryAction={(item: any) => handleOpenDrawer(item.id)}
                    handleDownloadAction={(item: any) => handleDownloadDocument(item)}
                    handleDeleteAction={(item: any) => handleDeleteDocument(item)}
                    headers={DocumentHeaders}
                    withActions={['history', 'download', 'delete']}
                    loading={savingDownload || loading}
                    hiddenColumns={{ showDocuments: false }}
                    options={documents?.data}
                    hideFooterPagination
                    rowsPerPage={rowsPerPage}
                    getRowId
                />
                <CustomPagination data={documents} setFilters={setFilters} filters={filters} />
            </>
        );
    }, [
        documents,
        rowsPerPage,
        setFilters,
        loading,
        savingDownload,
        handleOpenDrawer,
        filters,
        handleDownloadDocument,
        handleDeleteDocument
    ]);

    return (
        <Box
            sx={{
                '& .MuiDataGrid-overlayWrapper': {
                    height: !documents?.data?.length ? '150px' : 0
                }
            }}
        >
            <RenderTable />
        </Box>
    );
};

export default DataTableContainer;
